<script lang="ts">
import { computed } from 'vue';

import './text.css';

export interface PhxsgTextProps {
  use?: string;
  variant?: string;
  size?: string;
  align?: string;
  wrap?: string;
  truncate?: boolean;
  lineClamp?: number;
  uppercase?: boolean;
}
</script>

<script setup lang="ts">
const {
  use = 'span',
  variant,
  size,
  align,
  wrap,
  truncate = false,
  lineClamp,
  uppercase = false,
} = defineProps<PhxsgTextProps>();

const rootClasses = computed(() => {
  return [
    'phxsg-text',
    {
      [`phxsg-text--${variant}-${size}`]: variant && size,
      [`phxsg-text--align-${align}`]: align,
      'phxsg-text--truncate': truncate,
      [`phxsg-text-${wrap}`]: wrap,
      'phxsg-text--uppercase': uppercase,
    },
  ];
});

const rootStyles = computed(() => {
  const styles: Record<string, string | number> = {};

  if (lineClamp && lineClamp > 0) {
    styles['--this-text-line-clamp'] = lineClamp;
  }

  return styles;
});
</script>

<template>
  <component :is="use" :class="rootClasses" :style="rootStyles">
    <template v-if="truncate">
      <span class="phxsg-text__ellipsis-wrapper">
        <slot />
      </span>
    </template>

    <template v-else>
      <slot />
    </template>
  </component>
</template>
